import h from '../img/h.jpg'
import b1 from '../img/b1.jpg'
import r from '../img/r.jpg'
import d from '../img/d.jpg'
import a from '../img/a.jpg'
import t from '../img/t.jpg'
export const ImageData = [
    {
        ImageNo: '1/6',
        ImageName: 'AMPHIBIANS',
        ImageSrc: a
    },
    {
        ImageNo: '2/6',
        ImageName: 'REPTILES',
        ImageSrc: r
    },
    {
        ImageNo: '3/6',
        ImageName: 'BIRDS',
        ImageSrc: b1
    },
    {
        ImageNo: '4/6',
        ImageName: 'FISHES',
        ImageSrc: d
    },
{
        ImageNo: '5/6',
        ImageName: 'HERBIVOROUS',
        ImageSrc: h
    },
{
        ImageNo: '6/6',
        ImageName: 'Tiger',
        ImageSrc: t
    }
];